import { Category } from '@modules/common/types';
import { getCategoryTypeFromString } from '@modules/common/utils';
import { TaxonomyActionType } from '@modules/taxonomy/store/taxonomyActionType';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { capitalize } from 'lodash';
import { CategoryIcon } from '../CategoryIcon';
import { ReasonCategoryInputHelper } from '../ReasonCategoryInputHelper';

interface ReviewReasonCategorySelectProps {
  sxProps?: SxProps<Theme>;
}

export const ReviewReasonCategorySelect = ({
  sxProps,
}: ReviewReasonCategorySelectProps) => {
  const dispatch = useTaxonomyStore(({ dispatch }) => dispatch);

  const reasonCategory = useTaxonomyStore(
    ({ createReasonV3State: { reason } }) => reason?.category,
  );

  const onCategoryChange = (event: SelectChangeEvent) => {
    dispatch({
      type: TaxonomyActionType.SET_CREATE_REASONV3_STATE,
      payload: {
        reason: {
          category: event.target.value as Category,
        },
      },
    });
  };

  const renderCategorySelectMenuItem = (category: Category) => {
    return (
      <Stack spacing={1} direction="row" alignItems="center">
        <Box>
          <CategoryIcon category={getCategoryTypeFromString(category)} />
        </Box>
        <Typography variant="body2">{capitalize(category)}</Typography>
      </Stack>
    );
  };

  return (
    <FormControl>
      <InputLabel id="category-select-label" size="small">
        Category
      </InputLabel>
      <Select
        labelId="category-select-label"
        id="category-select-label"
        value={reasonCategory}
        onChange={onCategoryChange}
        label="Category"
        size="small"
        sx={sxProps}
      >
        <MenuItem value={Category.Help}>
          {renderCategorySelectMenuItem(Category.Help)}
        </MenuItem>
        <MenuItem value={Category.Improvement}>
          {renderCategorySelectMenuItem(Category.Improvement)}
        </MenuItem>
        <MenuItem value={Category.Praise}>
          {renderCategorySelectMenuItem(Category.Praise)}
        </MenuItem>
        <MenuItem value={Category.Complaint}>
          {renderCategorySelectMenuItem(Category.Complaint)}
        </MenuItem>
      </Select>
      <ReasonCategoryInputHelper />
    </FormControl>
  );
};
